import { render, staticRenderFns } from "./sidebar-reservations-empty.vue?vue&type=template&id=89ca9586&"
import script from "./sidebar-reservations-empty.vue?vue&type=script&lang=ts&"
export * from "./sidebar-reservations-empty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports